import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-create-shipment-confirm-dialog',
  templateUrl: './create-shipment-confirm-dialog.component.html',
  styleUrl: './create-shipment-confirm-dialog.component.scss'
})
export class CreateShipmentConfirmDialogComponent implements OnInit,OnDestroy {
  actions=[];
  shipment;
  private destroy$ = new Subject<void>();

  constructor( 
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CreateShipmentConfirmDialogComponent>,
  ){}

  ngOnInit(): void {
    this.shipment= this.data.shipment;
    this.actions =[
      { text: "Cancel", buttonStyle: "underline" },
      { text: "Confirm" },
    ];
  }

  close(e?) {
    this.dialogRef.close(e);
  }

  round(a){
    return Math.floor(a)
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
